export class Abilities {
    static MobileAppContactData = 'MobileAppContactData';
    static MobileAppRemindersList = 'MobileAppRemindersList';
    static AccountingCostInvoiceConfirm = 'AccountingCostInvoiceConfirm';
    static AccountingCostInvoiceCanManage = 'AccountingCostInvoiceCanManage';
    static AccountingInternalCostInvoiceCanManage = 'AccountingInternalCostInvoiceCanManage';
    static AccountingInternalCostInvoiceForClassificationCanManage = 'AccountingInternalCostInvoiceForClassificationCanManage';
    static AccountingCostReportCanManage = 'AccountingCostReportCanManage';
    static AccountingSalesCanManage = 'AccountingSalesCanManage';
    static AccountingCostInvoiceCanCancelConfirmation = 'AccountingCostInvoiceCanCancelConfirmation';
    static AccountingCostInvoiceCanRemove = 'AccountingCostInvoiceCanRemove';
    static ClaimReconcilationAccess = 'ClaimReconcilationAccess';
    static CanSeeInspectionCardAmountDetails = 'CanSeeInspectionCardAmountDetails';
    static CanExcludeInspectionsElementsFromPaintingDiscount = 'CanExcludeInspectionsElementsFromPaintingDiscount';
    static AccountingInvoiceConfirm = 'AccountingInvoiceConfirm';
    static AccountingInvoiceCanManage = 'AccountingInvoiceCanManage';
    static AccountingInvoiceCanCancelConfirmation = 'AccountingInvoiceCanCancelConfirmation';
    static AccountingInvoiceCanRemove = 'AccountingInvoiceCanRemove';
    static CanSeeInspectionCardProvisionDetails = 'CanSeeInspectionCardProvisionDetails';
    static CanRemoveClaim = 'CanRemoveClaim';
    static CanRemoveSignedDocument = 'CanRemoveSignedDocument';
    static Merge15To40DentsOnInspectionCard = 'Merge15To40DentsOnInspectionCard';
    static AllowedMassiveClaimsHandling = 'AllowedMassiveClaimsHandling';
    static AllowedMultipleClaimsProcessing = 'AllowedMultipleClaimsProcessing';
    static CanSetBusinessTripReimbursedState = 'CanSetBusinessTripReimbursedState';
    static CanCancelBusinessTripReimbursedState = 'CanCancelBusinessTripReimbursedState';
    static CanHaveAccessActivitiesForPartnersReport = 'CanHaveAccessActivitiesForPartnersReport';
    static CanHaveAccessCostAndSalesInvoicesForPeriodReport = 'CanHaveAccessCostAndSalesInvoicesForPeriodReport';
    static CanHaveAccessClaimsReconcilationForPeriodReport = 'CanHaveAccessClaimsReconcilationForPeriodReport';
    static CanHaveAccessCostEstimationsValuesForClaimsReport = 'CanHaveAccessCostEstimationsValuesForClaimsReport';
    static CanHaveAccessClaimsProcessingInfosReport = 'CanHaveAccessClaimsProcessingInfosReport';
    static CanHaveAccessToIntegrationTab = 'CanHaveAccessToIntegrationTab';
    static MobileAppOcrInSearchClaims = 'MobileAppOcrInSearchClaims';
    static ExcelExportFromClaimsSearch = 'ExcelExportFromClaimsSearch';
    static AccessToBusinessTripManagement = 'AccessToBusinessTripManagement';
    static CanMakeBusinessTripsFromMobile = 'CanMakeBusinessTripsFromMobile';
    static CanHaveAccessToInvoicingBoard = 'CanHaveAccessToInvoicingBoard';
    static AccountingInvoiceCanEditConfirmed = 'AccountingInvoiceCanEditConfirmed';
    static CanHaveAccessCostInvoicesForPeriodReport = 'CanHaveAccessCostInvoicesForPeriodReport';
    static AdminPanelAccess = 'AdminPanelAccess';
    static CanHaveAccessAccountingDashboard = 'CanHaveAccessAccountingDashboard';
    static CanHaveAccessSaleInvoicesForPeriodReport = 'CanHaveAccessSaleInvoicesForPeriodReport';
    static CanEditHelpText = 'CanEditHelpText';
    static CanHaveAccessInspectionCardCalculationsReport = 'CanHaveAccessInspectionCardCalculationsReport';
    static CanHaveAccessInspectionCardValuesForTechnicianReport = 'CanHaveAccessInspectionCardValuesForTechnicianReport';
    static CanHaveAccessToOrderingPartyInfo  = 'CanHaveAccessToOrderingPartyInfo';
     static ServicePanelAccess = 'ServicePanelAccess';
     static CanRegisterClaim = 'CanRegisterClaim';
  }
